import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';
import { normalizeDecimalValue } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

type TStateAidMatrixRow = {
  label: string;
  mmsp: string;
  group: string;
  numeric?: boolean;
};

interface IStateAidMatrixProps {
  title: string;
  prefix: string;
  nestedPrefix?: boolean;
  rows: readonly TStateAidMatrixRow[];
  disabled: boolean;
}

export const StateAidMatrix: React.FC<IStateAidMatrixProps> = ({
  title,
  prefix,
  nestedPrefix = false,
  rows,
  disabled,
}) => (
  <Box sx={documentGenerationFormStyles.section}>
    <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
      {title}
    </Typography>
    <TableContainer sx={financialConditionGenerationStyles.editableTableContainer}>
      <Table sx={{ ...financialConditionGenerationStyles.editableTable, minWidth: 980 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={financialConditionGenerationStyles.editableTableHeaderCell}>
              Показник
            </TableCell>
            <TableCell sx={financialConditionGenerationStyles.editableTableHeaderCell}>
              ММСП
            </TableCell>
            <TableCell sx={financialConditionGenerationStyles.editableTableHeaderCell}>
              Група пов’язаних з ММСП контрагентів
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.label}>
              <TableCell sx={financialConditionGenerationStyles.editableTableCell}>
                {row.label}
              </TableCell>
              <TableCell sx={financialConditionGenerationStyles.editableTableCell}>
                <FormInput
                  name={nestedPrefix ? `${prefix}.${row.mmsp}` : `${prefix}${row.mmsp}`}
                  label={row.label}
                  disabled={disabled}
                  fullWidth
                  inputProps={row.numeric ? { inputMode: 'decimal' } : undefined}
                  normalizeOnBlur={row.numeric ? normalizeDecimalValue : undefined}
                />
              </TableCell>
              <TableCell sx={financialConditionGenerationStyles.editableTableCell}>
                <FormInput
                  name={nestedPrefix ? `${prefix}.${row.group}` : `${prefix}${row.group}`}
                  label={row.label}
                  disabled={disabled}
                  fullWidth
                  inputProps={row.numeric ? { inputMode: 'decimal' } : undefined}
                  normalizeOnBlur={row.numeric ? normalizeDecimalValue : undefined}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);
